import React from 'react';
import { Empty } from 'antd';
import InnerCard from '../../../../../components/InnerCard/InnerCard';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import { CardChangeButton } from '../../../../../../../components/Card';
import EditRoomCommentModal from '../../../../../components/modals/EditRoomCommentModal/EditRoomCommentModal';
import commonStyles from '../../../AboutRoom.module.scss';
import styles from '../CommonInfoBlock.module.scss';

const CommentCard = ({ room }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <InnerCard
      title="Комментарий"
      action={
        <CardChangeButton
          text={room?.comment ? 'Редактировать' : 'Добавить'}
          className={commonStyles.innerCardAction}
          onClick={showModal}
        />
      }
    >
      {room?.comment ? (
        <p className={styles.text}>{room.comment}</p>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет комментария"
        />
      )}
      <EditRoomCommentModal
        visible={visible}
        room={room}
        onCancel={hideModal}
      />
    </InnerCard>
  );
};

export default CommentCard;
